import { Uuid } from '@manigo/manigo-domain-typings';

import { HttpService } from 'services/http';
import { HttpRequestConfig } from 'services/http/httpService.types';

import {
    OutgoingPaymentPayload,
    PaymentPayload,
} from 'store/transaction/actions';


export const getAllTransactionsAPI = (queryParams) =>
    HttpService.get('/v4/transactions', queryParams);

export const getTransactionIdDetails = (transactionUuid: Uuid) =>
    HttpService.get(`/v4/transactions/${transactionUuid}`);

export const uploadReceiptFile = (file: File, transactionId: string) => {
    return HttpService.post(
        `/v3/transactions/${transactionId}/attachments`,
        file,
    );
};

export const updateReceiptTitle = (
    transactionId: string,
    receiptId: string,
    title: string,
) => {
    return HttpService.patch(
        `/v3/transactions/${transactionId}/attachments/${receiptId}`,
        { title },
    );
};


export const deleteTransactionReceiptById = (
    transactionId: string,
    receiptId: string,
) => {
    return HttpService.delete(
        `/v3/transactions/${transactionId}/attachments/${receiptId}`,
    );
};

export const createNewPaymentAPI = (
    requestPayload: PaymentPayload | OutgoingPaymentPayload,
    config: HttpRequestConfig,
) => HttpService.post('/v4/payments/create', requestPayload, config);

export const getTransactionById = (id: string) => {
    return HttpService.get(`/v3/transactions/${id}`);
};
